module.exports = __webpack_public_path__ + "img/img_nav_bet.a339cb13.svg";